import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginSampleData } from "../usePluginSampleData"
import { TryAddOnItem } from "./TryAddOnItem"

export const TryAddOnItemColorfinder = () => {
    const plugin = usePluginSampleData(NovaPluginIds.Colorfinder)
    return <TryAddOnItem plugin={plugin} />
}
